import(/* webpackMode: "eager" */ "/app/src/app/(STATIC)/home/page.tsx");
